<template>
  <v-navigation-drawer v-model="drawer" color="white"  disable-resize-watcher>
    <v-list nav>
      <v-list-item
        v-for="item in Nav"
        :key="item.route"
        link
        :title="item.text"
        class="text-font-light"
      />
    </v-list>
  </v-navigation-drawer>

  <v-app-bar color="white" flat class="border-b">
    <template #prepend>
      <v-app-bar-nav-icon
        v-if="$vuetify.display.smAndDown"
        @click="drawer = !drawer"
      />
    </template>

    <v-app-bar-title>
      <div>
      <v-img 
        max-width="170"
        width="150"
        position="left"
        xsrc="../assets/ONICET.png" 
        src="../a3/ONICET_Logo.jpg" 

        @click="navigateTo('/')"
        contain 
      />
    </div>
    </v-app-bar-title>
    <v-spacer/>

    

    <div class="d-md-flex d-none ga-4 mx-auto">

      
    <!-- Platform -->

    
  <!-- Resources -->

  <v-menu
      class="text-center"
      width="300"
      color="white"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          href="./"
          xappend-icon="mdi-chevron-down"
          class="text-none px-8 text-subtitle-1"
          flat
          style="text-transform: none"
          v-ripple="false"
          v-bind="props"
          color="grey"
          text="Platform"
        />
      </template>

    </v-menu>

  <v-menu
      class="text-left"
      width="300"
      color="white"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          text="Services"
          append-icon="mdi-chevron-down"
          class="text-left px-8 text-subtitle-1"
          flat
          style="text-transform: none"
          v-ripple="false"
          v-bind="props"
          color="grey"
        ></v-btn>
      </template>

      <v-list style="background-color: white">
        <v-list-item
          v-for="(item, i) in Services"
          :xprepend-icon="item.icon"
          :key="i"
          color="white"
          @click="selectMenuItem(item)"
          v-ripple="false"
        >
          <v-list-item-title class="ml-4" style="cursor: pointer">
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>





    








    
    <!-- Use Cases

    <v-menu
      class="text-left"
      width="300"
      color="white"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          text="OCM"
          append-icon="mdi-chevron-down"
          class="text-left px-8 text-subtitle-1"
          flat
          style="text-transform: none"
          v-ripple="false"
          v-bind="props"
          color="grey"
        ></v-btn>
      </template>

      <v-list style="background-color: white">
        <v-list-item
          v-for="(item, i) in OCM"
          :xprepend-icon="item.icon"
          :key="i"
          color="white"
          @click="selectMenuItem(item)"
          v-ripple="false"
        >
          <v-list-item-title class="ml-4" style="cursor: pointer">
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->


    <!-- Methodology -->


    <!-- <v-menu
      class="text-left"
      width="300"
      color="black"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          text="Methodology"
          class="text-left px-8 text-subtitle-1"
          flat
          style="text-transform: none"
          v-ripple="false"
          v-bind="props"
          color="grey"
          href="./Methodology"
        />
      </template>


    </v-menu> -->


    <!-- Use Cases -->

    <!-- <v-menu
      class="text-left"
      width="300"
      color="white"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          text="Use Cases"
          append-icon="mdi-chevron-down"
          class="text-left px-8 text-subtitle-1"
          flat
          style="text-transform: none"
          v-ripple="false"
          v-bind="props"
          color="grey"
        ></v-btn>
      </template>

      <v-list style="background-color: white">
        <v-list-item
          v-for="(item, i) in UseCases"
          :xprepend-icon="item.icon"
          :key="i"
          color="white"
          @click="selectMenuItem(item)"
          v-ripple="false"
        >
          <v-list-item-title class="ml-4" style="cursor: pointer">
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->




  <!-- Resources -->

        <v-menu
      class="text-left"
      width="300"
      color="white"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          text="Resources"
          append-icon="mdi-chevron-down"
          class="text-left px-8 text-subtitle-1"
          flat
          style="text-transform: none"
          v-ripple="false"
          v-bind="props"
          color="grey"
        ></v-btn>
      </template>

      <v-list style="background-color: white">
        <v-list-item
          v-for="(item, i) in Resources"
          :xprepend-icon="item.icon"
          :key="i"
          color="white"
          @click="selectMenuItem(item)"
          v-ripple="false"
        >
          <v-list-item-title class="ml-4" style="cursor: pointer">
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>






    <!-- <v-btn
      @click.prevent="navigateTo('/Assessment')"
      text="OCriteria Model"
      style="text-transform: none"
      color="grey"
      v-ripple="false"
    /> -->

    <!-- <v-btn
      @click.prevent="navigateTo('/Assessment')"
      text="Assessment"
      style="text-transform: none"
      color="grey"
      v-ripple="false"
    ></v-btn>
    <v-btn
      @click.prevent="navigateTo('/Technology')"
      text="Technology"
      style="text-transform: none"
      color="grey"
      v-ripple="false"
    ></v-btn>
    <v-btn
      @click.prevent="navigateTo('/Consulting')"
      text="Consulting"
      style="text-transform: none"
      color="grey"
      v-ripple="false"
    ></v-btn> -->
    <v-btn
      @click.prevent="navigateTo('/Connect')"
      text="Get Started"
      style="text-transform: none"
      color="grey"
      v-ripple="false"
    ></v-btn>
    <!-- <v-btn
      @click.prevent="navigateTo('/GetStarted')"
      text="Get Started"
      style="text-transform: none"
      color="grey"
    ></v-btn> -->


      
















    </div>
    <spacer class="ml-16"/>



    

    <div class="d-flex flex-1-1-0 pe-3">
      <!-- <v-btn append-icon="mdi-chevron-right" class="ms-auto text-none" slim text="Login" /> -->

      <v-btn
        text="Login" href="/Login"
        class="text-center font-weight-bold px-8 "
        style="text-transform: none"
        variant="tonal"
        dark
        color="#009D8B"

      />

    </div>



  </v-app-bar>

</template>
  





<script setup lang="js">

import { shallowRef, ref, watch } from 'vue'
import { useRouter } from "vue-router";

const drawer = shallowRef(false)

const router = useRouter();
const navigateTo = (route) => {
  router.push(route);
};


const selectedMenuItemText = ref("Menu");

const selectMenuItem = (menuItem) => {
  selectedMenuItemText.value = menuItem.text;
  navigateTo(menuItem.route);
};

// const Platform =  [
// { text: "Evaluate", icon: "x-account-group", route: "/Evaluate" },
// { text: "Work ", icon: "x-account-group", route: "/Workbook" },
// { text: "Operate", icon: "x-home", route: "/Operate" },
// { text: "Connect", icon: "x-home", route: "/Connect" },
// { text: "Build", icon: "x-home", route: "/Build" },

// ];




// const nav = [
// { text: "Drivers", icon: "x-account-group", route: "/Drivers" },  
// { text: "Learning", icon: "x-lightbulb-on", route: "/Learning" },
// { text: "WorkBook", icon: "x-lightbulb-on", route: "/Workbook" },
// { text: "OKR", icon: "x-lightbulb-on", route: "/Strategy" },
// { text: "Teams", icon: "x-currency-usd", route: "/Teams" },
// { text: "Auto Insights", icon: "x-currency-usd", route: "/Teams" },



// ];

// const OCM = [
// // { text: "OCriteria Model", icon: "x-home", route: "/OCM" },
// { text: "Value System", icon: "x-home", route: "/ValueSystem" },
// // { text: "Impact Theory", icon: "x-account-group", route: "/Assessment" },

// ];

const UseCases =  [
{ text: "Change", icon: "x-account-group", route: "/Assessment" },
{ text: "Product Development", icon: "x-account-group", route: "/Assessment" },
{ text: "Customer Experience ", icon: "x-home", route: "/OCM" },




];


const Services =  [
{ text: "Advisory", icon: "x-home", route: "/Optimize" },
{ text: "Innovation", icon: "x-home", route: "/Build" },
{ text: "CEO Services", icon: "x-home", route: "/Manage" },
{ text: "Parallel Operations", icon: "x-home", route: "/Operate" },


];


const Resources =  [
{ text: "Company", icon: "x-home", route: "/Company" },
{ text: "Team", icon: "x-home", route: "/Team" },
// { text: "Research", icon: "x-home", route: "/Research" },
{ text: "Community", icon: "x-home", route: "/Community" },


];


const Nav =  [
{ text: "Home", icon: "x-home", route: "/" },

{ text: "Platform", icon: "x-home", route: "/About" },
{ text: "Methodology", icon: "x-home", route: "/Community" },
{ text: "Use cases", icon: "x-home", route: "/Learning" },
{ text: "Resources", icon: "x-home", route: "/Datasets" },
{ text: "Get Started", icon: "x-home", route: "/Datasets" },



];





// const router = useRouter();
// const navigateTo = (route) => {
// router.push(route);
// };


// const selectedMenuItemText = ref("Menu");

// const selectMenuItem = (menuItem) => {
// selectedMenuItemText.value = menuItem.text;
// navigateTo(menuItem.route);
// };
// //


</script>



<style scoped>

.v-bg {
  filter: blur(56px);
  pointer-events: none;
}

.v-bg > div {
  background: linear-gradient(
    to bottom right,
    rgb(var(--v-theme-primary)),
    rgb(var(--v-theme-error))
  );
  z-index: -10;
  clip-path: polygon(20% 50%, 27% 66%, 41% 66%, 50% 50%, 41% 34%, 27% 34%, 20% 50%, 55% 50%, 62% 66%, 76% 66%, 85% 50%, 76% 34%, 62% 34%, 55% 50%, 30% 50%, 37% 66%, 51% 66%, 60% 50%, 51% 34%, 37% 34%, 30% 50%);
}
</style>
